// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Filter from '../_raw/ui/icon_filter.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Filter);
